exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__crypto-card___25pJ4{display:flex;background:rgba(63,76,107,.35);min-width:auto;min-height:auto;width:24rem;height:14rem;font-family:Roboto;padding:1rem}", ""]);

// exports
exports.locals = {
	"crypto-card": "styles__crypto-card___25pJ4"
};